<template>
  <ins
    class="adsbygoogle"
    style="display:block"
    data-ad-format="fluid"
    data-ad-layout-key="-ed+6k-30-ac+ty"
    data-ad-client="ca-pub-5453692719230487"
    data-ad-slot="5173870163"
  ></ins>
</template>

<script
  setup
  lang="ts"
>
import { loadScript } from '~/helpers/helpers';

onMounted(() => {
  loadScript("https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5453692719230487", true, "anonymous")
    .then(() => {
      (adsbygoogle = window.adsbygoogle || []).push({});
    });
});
</script>
